import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Image from '../../atomic/Images/FittedImage';

const ENT_PLACEHOLDER = require('../../../assets/entity_placeholder.jpg').default;
const TV_ASSET = require('../../../assets/bettertvscreen3.png').default;

const Container = styled.div`
  position: relative;
  display: flex;
  width: 185px;
  height: 130px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const TVwrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-image: url(${props => props.background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 85%;
  height: 85%;
  margin-right: auto;
  margin-left: 5px;
`;

const TVasset = styled(Image)`
  position: absolute;
`;

const TVBox = ({ url, ...other }) => {
  return (
    <Container {...other}>
      <TVwrapper background={url || ENT_PLACEHOLDER} />
      <TVasset src={TV_ASSET} scale={.1}/>
    </Container>
  )
}

TVBox.propTypes = {
  url: PropTypes.string,
};

TVBox.defaultProps = {
  url: ENT_PLACEHOLDER
};

export default TVBox;
